import { render, staticRenderFns } from "./radish.vue?vue&type=template&id=196ae59c&"
import script from "./radish.vue?vue&type=script&lang=js&"
export * from "./radish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports